import { render, staticRenderFns } from "./ReportNv.vue?vue&type=template&id=efe2a9e0&scoped=true&"
import script from "./ReportNv.vue?vue&type=script&lang=js&"
export * from "./ReportNv.vue?vue&type=script&lang=js&"
import style0 from "./ReportNv.vue?vue&type=style&index=0&id=efe2a9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe2a9e0",
  null
  
)

export default component.exports